import React, {useEffect, useState} from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Box,
  Typography,
  TextField, Card, Divider, InputAdornment, IconButton,
} from '@mui/material';
import { useStyles } from "./EnrollModalStyles";
import {HTTP_ENDPOINTS} from "../../../../clients/clients.constants";
import {http} from "../../../../clients/http/http.client";
import InputText from "../../../Inputs/InputText/InputText";
import {ClearIcon} from "@mui/x-date-pickers";

const EnrollModal = ({
  type = 'equipment',
  open,
  handleClose,
  row,
  tagsInputs = [],
  equipmentInputs = [],
  setEnrollingEntity,
  enrollingEntity,
  tagsList = [],
  equipmentList = [],
  handleAddEquipmentSuccess
}) => {
  const dialogStyles = useStyles.dialog;
  const dialogContentBoxStyles = useStyles.dialogContentBox;
  const formControlStyles = useStyles.formControl;
  const selectStyles = useStyles.select;
  const menuItemStyles = useStyles.menuItem;
  const linkButtonStyles = useStyles.linkButton;
  const detailsStyles = useStyles.details;
  const detailsHeadingStyles = useStyles.detailsHeading;
  const detailsTextStyles = useStyles.detailsText;

  useEffect(() => {
    if (type === 'equipment') {
      setEnrollingEntity({ ...enrollingEntity, equipmentKey: row.id });
    }

    if (type === 'tag') {
      setEnrollingEntity({ ...enrollingEntity, tagId: row.tagId });
    }
  }, [])

  const handleTagChange = (key, value, inputs) => {
    const targetTag = inputs?.options?.find((tag) => tag.name === value);

    const updatedValues = { ...enrollingEntity, [key]: value };
    setEnrollingEntity({ ...updatedValues, tagType: targetTag?.tagType || '' });
  };

  const handleEquipmentChange = (key, value) => {
    const targetEquipment = equipmentList.find((tag) => tag.number === value);
    const updatedValues = { ...enrollingEntity, [key]: value };
    setEnrollingEntity({ ...updatedValues, type: targetEquipment?.type || '', equipmentKey: targetEquipment?.id || '' });
  };

  const handleSubmit = async () => {
    try {
      const res = await http.client.put(HTTP_ENDPOINTS.ENROLL_TAG, enrollingEntity);
      await handleAddEquipmentSuccess();
    } catch (e) {
      console.log(e);
    }

    handleClose();
  };

  const EquipmentTypeInputs = () => {
    const [search, setSearch] = useState('');

    return (
      tagsInputs.filter((e) => e.key === 'tagId').map((input, index) => (
        <FormControl fullWidth key={index} sx={formControlStyles}>
          <InputLabel sx={menuItemStyles} >{input.label}</InputLabel>
          <Select
            value={enrollingEntity[input.key] || ""}
            onChange={(e) => {
              e.preventDefault();
              e.stopPropagation()
              handleTagChange(input.key, e.target.value, input)
            }}
            label={input.label}
            sx={selectStyles}
            onKeyDown={(e) => e.stopPropagation()}
            endAdornment={
              enrollingEntity?.[input.key] && (
                <InputAdornment sx={{ marginRight: "10px" }} position="end">
                  <IconButton
                    onClick={() => {
                      handleTagChange(input.key, '')
                    }}
                  >
                    <ClearIcon sx={{ fontSize: "14px", }}></ClearIcon>
                  </IconButton>
                </InputAdornment>
              )
            }
          >
            <MenuItem
              onKeyDown={(e) => {
                e.stopPropagation()
              }}
              onClick={() => { }}
            >
              <InputText width="265px" value={search} onChangeFn={(value) => setSearch(value) } />
            </MenuItem>
            {input.options
              .filter((option) => search.length ? option.name.toLowerCase().includes(search.toLowerCase()) : true)
              .filter((option) => row.siteId === option.siteId || !option.siteId)
              .map((option, i) => (
                <MenuItem sx={menuItemStyles} key={i} value={option?.name}>
                  {option?.name}
                </MenuItem>
            ))}
          </Select>
        </FormControl>
      ))
    )
  };

  const TagsTypeInputs = () => {
    const [search, setSearch] = useState('');

    return (
      equipmentInputs.filter((e) => e.key === 'equipmentNumber').map((input, index) => (
        <FormControl fullWidth key={index} sx={formControlStyles}>
          <InputLabel sx={menuItemStyles} >{input.label}</InputLabel>
          <Select
            value={enrollingEntity?.[input.key] || ""}
            onChange={(e) => handleEquipmentChange(input.key, e.target.value)}
            label={input.label}
            sx={selectStyles}
            onKeyDown={(e) => e.stopPropagation()}
            endAdornment={
              enrollingEntity?.[input.key] && (
                <InputAdornment sx={{ marginRight: "10px" }} position="end">
                  <IconButton
                    onClick={() => {
                      handleEquipmentChange(input.key, '')
                    }}
                  >
                    <ClearIcon sx={{ fontSize: "14px", }}></ClearIcon>
                  </IconButton>
                </InputAdornment>
              )
            }
          >
            <MenuItem
              onKeyDown={(e) => {
                e.stopPropagation()
              }}
              onClick={() => { }}
            >
              <InputText width="265px" value={search} onChangeFn={(value) => setSearch(value) } />
            </MenuItem>
            {input
              .options
              .filter((option) => search.length ? option.name.toLowerCase().includes(search.toLowerCase()) : true)
              .filter((option) => option?.siteId ? option.siteId === row.siteId : true)
              .map((option, i) => (
              <MenuItem sx={menuItemStyles} key={i} value={option?.name}>
                {option?.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ))
    )
  };

  const getEquipmentDetailsContent = (key = '') => {
    if (type === 'equipment') {
      return row?.[key];
    }

    if (type === 'tag') {
      return enrollingEntity?.[key];
    }
  }

  const getTagDetailsContent = (key = '') => {
    if (type === 'equipment') {
      return enrollingEntity?.[key];
    }

    if (type === 'tag') {
      return row?.[key];
    }
  }

  return (
    <Dialog open={open} onClose={handleClose} sx={dialogStyles}>
      <Box
        sx={{
          borderRadius: '8px',
          padding: '2px',
          background: 'linear-gradient(180deg, #5AC4F7 0%, #87E49E 100%)',
        }}
      >
        <Box
          sx={{
            backgroundColor: '#F6F6F6',
            borderRadius: '8px',
            padding: '16px',
          }}
        >

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: "16px" }}>
            <DialogTitle
              sx={{
                fontWeight: 'bold',
                textAlign: 'left',
                color: '#0D3B66',
              }}
            >
              Enroll Tag
            </DialogTitle>
            <IconButton onClick={handleClose}>
              <ClearIcon />
            </IconButton>
          </Box>
          <DialogContent>
            <Box sx={dialogContentBoxStyles}>
              {
                type === 'equipment' ?
                  <EquipmentTypeInputs /> :
                  <TagsTypeInputs />
              }

              <Card sx={detailsStyles}>
                <Typography sx={detailsHeadingStyles}>Equipment Details</Typography>
                <Typography sx={detailsTextStyles}>{getEquipmentDetailsContent('type') || '-'}</Typography>
                <Typography sx={detailsTextStyles}>{getEquipmentDetailsContent(type === 'equipment' ? 'number' : 'equipmentNumber') || '-'}</Typography>
              </Card>

              <Divider>Enroll to</Divider>

              <Card sx={detailsStyles}>
                <Typography sx={detailsHeadingStyles}>Tags Details</Typography>
                <Typography sx={detailsTextStyles}>{getTagDetailsContent('tagType') || '-'}</Typography>
                <Typography sx={detailsTextStyles}>{getTagDetailsContent('tagId') || '-'}</Typography>
              </Card>

              <Button
                variant="contained"
                sx={linkButtonStyles}
                onClick={handleSubmit}
              >
                Link
              </Button>
            </Box>
          </DialogContent>
        </Box>
      </Box>
    </Dialog>
  );
};

export default EnrollModal;